import React from "react";
import {Spinner} from "react-bootstrap";
import FolieLayout from "./FolieLayout.jsx";
import BeispielArtikelAuswahl from "./BeispielArtikelAuswahl.jsx";
import ArtikelZeitstrahl from "../ArtikelZeitstrahl.jsx";

export default function Folie4Szenarien({beispielArtikel, onBeispielArtikelAendern, artikelDaten, ladeGerade}) {
    return (
        <FolieLayout
            nummer={5}
            titel="Der Bestand in die Zukunft"
            hilfe="Bestand heute minus offene Aufträge minus Bedarf plus geplante Zuläufe, Woche für Woche fortgeschrieben – in drei Szenarien."
            text={
                <p className="mb-0">
                    Der heutige Bestand wird Woche für Woche fortgeschrieben: minus dem erwarteten Verbrauch, plus dem,
                    was Cosmos noch liefert. Weil nicht jede Lieferung wie geplant kommt, zeigt der Bereich drei
                    Linien: <strong>sicher</strong> – nur, was Cosmos bereits fest zugesagt hat, mit Verspätung
                    gerechnet; <strong>erwartet</strong> – die wahrscheinliche Entwicklung; <strong>bestellt</strong> –
                    der optimistische Fall, dass alles pünktlich kommt.
                </p>
            }
            leseHinweis="Die graue Fläche links ist der tatsächliche Bestand bis heute. Rechts davon die drei Linien – die sichere Linie liegt nie über der erwarteten, die erwartete nie über der bestellten."
        >
            <BeispielArtikelAuswahl wert={beispielArtikel} onChange={onBeispielArtikelAendern} />
            {!artikelDaten && ladeGerade && (
                <div className="d-flex justify-content-center py-4">
                    <Spinner animation="border" size="sm" role="status">
                        <span className="visually-hidden">Wird geladen…</span>
                    </Spinner>
                </div>
            )}
            {artikelDaten && (
                <ArtikelZeitstrahl
                    prognose={artikelDaten.prognose}
                    bestandshistorie={artikelDaten.bestandshistorie}
                    zulaeufe={artikelDaten.zulaeufe}
                    liefergelegenheiten={artikelDaten.liefergelegenheiten}
                    prognoseProtokoll={artikelDaten.prognose_protokoll}
                />
            )}
        </FolieLayout>
    );
}
